export type NavigationLink = {
  label: string;
  href?: string;
  description?: string;
  children?: NavigationLink[];
};

export const NavbarLinks: NavigationLink[] = [
  { label: 'Início', href: '/' },
  { label: 'História', href: '/history' },
  {
    label: 'Órgãos',
    children: [
      {
        label: 'Executivo',
        href: '/executive-body',
        description: 'Órgão executivo da freguesia',
      },
      {
        label: 'Assembleia de Freguesia',
        href: '/assembly',
        description: 'Órgão deliberativo da freguesia',
      },
    ],
  },
  { label: 'Notícias', href: '/news' },
  { label: 'Serviços', href: '/services' },
  { label: 'Documentos', href: '/documents' },
  { label: 'Agenda', href: '/events' },
  { label: 'Galerias', href: '/galleries' },
  {
    label: 'Transparência',
    children: [
      {
        label: 'Plano de Prevenção de Riscos',
        href: '/transparency/risk-prevention-plan',
        description: 'Gestão, corrupção e infrações conexas',
      },
      {
        label: 'Canal de Denúncias',
        href: '/transparency/whistleblowing',
        description: 'Lei n.º 93/2021',
      },
      {
        label: 'RGPD',
        href: '/privacy',
        description: 'Política de proteção de dados',
      },
    ],
  },
  { label: 'Contactos', href: '/contact' },
];

export const FooterLinks = {
  institucional: [
    { label: 'História', href: '/history' },
    { label: 'Junta de Freguesia', href: '/executive-body' },
    { label: 'Assembleia de Freguesia', href: '/assembly' },
    { label: 'Atas e Editais', href: '/documents?category=Atas,Editais' },
    { label: 'Contas', href: '/documents?category=Contas' },
  ],
  explorar: [
    { label: 'Agenda Cultural', href: '/events' },
    { label: 'Galerias', href: '/galleries' },
    { label: 'Notícias', href: '/news' },
  ],
};
